"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_saving(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-4{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#666;}.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-4{stroke:#e60000;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 191.54,
    height: 191.54
  }))), /*#__PURE__*/React.createElement("title", null, "saving-mid_espBP"), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_mid"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.62,102.28l-.33.87c-2.72,6.3-26.75,11.14-45.67,11.14-20.77,0-46.07-5.91-46.07-13.09,0-4.51,6.59-8.5,16.62-10.85h.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.71,102.26v27.85c-4.93,5.75-28.28,8.79-46.09,8.79s-41.16-4.2-46.07-10V101.13",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.08,123.8v29.32c-4.92,5.76-28.28,8.79-46.08,8.79s-41.16-4.2-46.07-9.95V134.64",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143,59.94c4.73,2.06,7.48,4.52,7.48,7.15,0,6.33-15.8,11.61-36.8,12.83",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M150.45,67.09V96c-4.92,5.77-28.28,8.79-46.08,8.79s-41.16-4.2-46.08-10V75.74",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 96,
    cy: 43.18,
    rx: 46.08,
    ry: 13.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.08,43.18V72.09c-4.92,5.77-28.28,8.79-46.08,8.79s-41.16-4.2-46.07-9.95V43.18",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M133.71,116.27c5.27,2.13,8.37,4.73,8.37,7.53,0,3.24-4.14,6.2-11,8.49",
    transform: "translate(0 0)"
  })));
}

var _default = ic_saving;
exports.default = _default;